import React from "react";
import { inject } from "mobx-react";

import InfoComponent from "./InfoComponent";
import LoadingComponent from "~/components/LoadingComponent";
import AlertComponent from "~/components/AlertComponent";
import { URL_APP_APP_BASE_PATH, PREVIEW_TYPE, IMAGE_TYPE, SHOW_TIME_MIDIA_MIN, SHOW_TIME_MIDIA_DEFAULT } from "~/configs/constants";
import { isEmptyOrNullStr, getVarFromUrl } from "../../helpers/utils";
import "share-api-polyfill";

@inject("ImageStore", "DeviceStore", "FileStore", "ProductStore", "FontStore", "PageStore", "OrganizationStore", "PreviewStore")
class InfoContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      image: {}
    };
  }

  async componentDidMount() {
    await this.getImage();
  }

  getImage = async () => {
    this.setState({
      isLoading: true,
    });

    const { ImageStore, DeviceStore, history } = this.props;
    let pageId = getVarFromUrl("pageId");
    let deviceId = getVarFromUrl("deviceId");
    const imageId = getVarFromUrl("infoId");    
    const hasImage = imageId !== undefined && parseInt(imageId) > 0;    
 
    await DeviceStore.setDeviceId(deviceId);
    let device = await DeviceStore.getDevice();

    let image = {};
    if (!hasImage){
      image.deviceId = deviceId;
      image.pageId = pageId;
      image.type = IMAGE_TYPE.notice;
      image.showTime = SHOW_TIME_MIDIA_DEFAULT;
    }
    else {
      image = await ImageStore.getImage(imageId);
      if (image === undefined || image === null){
        history.push("devices");
        return;
      }
      pageId = image.pageId;
      deviceId = image.deviceId;
    }
    
    if (image.name === undefined || image.name === null) image.name = "";
   
    this.setState({
      isLoading: false,
      device,
      image
    });
  };

  goDevice = () => {
    const { history } = this.props;
    history.push(`page?deviceId=${getVarFromUrl("deviceId")}&pageId=${getVarFromUrl("pageId")}&tab=${getVarFromUrl("tab")}`);
  };

  maintainImage = async () => {
    this.setState({
      isLoading: true
    });

    const { image } = this.state;
    const { ImageStore } = this.props;

    if (isEmptyOrNullStr(image.showTime) || image.showTime < SHOW_TIME_MIDIA_MIN) AlertComponent.error("Tempo de exibição da mídia deve ser maior ou igual a " + SHOW_TIME_MIDIA_MIN + " segundos");
    else {
      const formData = new FormData();
      formData.append("payload", JSON.stringify(image));

      const result = await ImageStore.maintainImage(formData);

      if (result === "") {
        AlertComponent.success("Mídia salva com successo");
        this.goDevice();
      }
      else 
        AlertComponent.error(result);
    }

    this.setState({
      isLoading: false
    });
  };

  onChange = async (e) => {
    const { image } = this.state;
    const updatedImage = {
      ...image,
      [e.target.name]: e.target.value     
    }

    this.setState({
      image: updatedImage
    });
  };

  preview = async () => {
    try {
      setTimeout(async() => {
        const iframe = document.getElementById("tagPreview");
        const fallback = document.getElementById("fallback");
        const loader = document.getElementById("loader");
        const { image } = this.state;
        const { PreviewStore } = this.props;
        const deviceId = getVarFromUrl("deviceId");
        const pageId = getVarFromUrl("pageId");

        fallback.style.display = "none";
        loader.style.display = "flex";
        iframe.style.opacity = 0; 

        let preview = {};
        try { image.product.description = image.customDescription; } catch {}
        preview.payload = JSON.stringify(image);
        preview.type = PREVIEW_TYPE.notice;
        preview.deviceId = deviceId;
        preview.pageId = pageId;
        preview = await PreviewStore.add(preview);
        
        const path = URL_APP_APP_BASE_PATH + "?preview=" + preview.previewId.toString();

        iframe.src = path;

        window.addEventListener("message", (event) => {
          if (event.data.msg === "PREVIEW_READY") {
            iframe.style.transition = "opacity 0.5s ease";
            iframe.style.opacity = 1;
            loader.style.display = "none";
            fallback.style.display = "none";
          }
        });
      }, 0);
    } catch {}
  };

  render() {
    const { isLoading, image } = this.state;
    return (
      <>
        {(isLoading && (
          <>
            <LoadingComponent />
          </>
        )) || (
          <div className="content content-xs" style={{overflow: "hidden"}} >
            <InfoComponent
              onChange={this.onChange}
              onClick={this.maintainImage}
              onCancel={this.goDevice}
              image={image}
              preview={this.preview}
            />            
          </div>
        )}
      </>
    );
  }
}

export default InfoContainer;